<!--拆分订单-->
<template>
  <el-dialog
    title="补加工单"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="min-dialog">
    <el-form :model="form" ref="form1">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form-item label="加工费" :label-width="formLabelWidth" prop="seedname">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="300"
                        :treeHeight="240" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form-item label="加工点" :label-width="formLabelWidth" prop="pcustomername">
            <el-select v-model="form.pcustomerserial" placeholder="请选择" >
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--<table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"-->
           <!--class="query-table">-->
      <!--<tr class="noborder">-->
        <!--<td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>-->
        <!--<td width="120">-->
          <!--<el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" >-->
            <!--<el-option-->
              <!--v-for="item in jxcstoreData"-->
              <!--:key="item.cangkucode"-->
              <!--:label="item.cangkuname"-->
              <!--:value="item.cangkucode">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</td>-->
      <!--</tr>-->
    <!--</table>-->

    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveOrder" class="qrbtn" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>


<script>

  import {getPrice} from '@/api/set/goodsprice';
  import {getParameterDetail} from '@/api/set/parameter';
  import {createmachiningOrder} from '@/api/set/csagreement'
  import {suppliers} from '@/api/set/externaldept';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';

  export default {
    name: 'AddMachinOrder',
    data() {
      return {
        dialogFormVisible: false,
        loading: false,
        parameterData: [],
        form: {
          seedname:"",
          seedcode:"",
          erpserial: "",
          pcustomerserial: "",
          pcustomername: '',
        },
        formLabelWidth: '120px',
        jxcstoreData: [],
        ptableData: [],
        controlData: {},
      }

    },
    methods: {
      changepcu(){

      },
      checktree1(guids, names, arr) {
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.pcustomername = ''
        this.form.pcustomerserial = ''
        this.ptableData = []
        if (this.form.seedcode == null || this.form.seedcode == '')
          return;

        suppliers({seedcodes: '["' + this.form.seedcode + '"]', search: ""}).then((response) => {
          this.ptableData = response.data.obj
          if (this.ptableData.length > 0) {
            this.form.pcustomername = this.ptableData[0].deptname
            this.form.pcustomerserial = this.ptableData[0].customerserial
          }
          //this.ptableData.push({deptname:'自己加工',customerserial:''})
        })
      },
      show(item) {
        this.ptableData = []
        this.form.erpserial=item.erpserial;
        this.form.pcustomername = ''
        this.form.pcustomerserial = ''
        this.form.seedcode = ''
        this.form.seedname = ''
        this.controlData = item;
        this.dialogFormVisible = true;
      },
      saveOrder() {
        if (!this.form.seedcode) {
          this.$message({
            message: '请选择加工费！',
            type: 'error'
          })
          return;
        }
        if (!this.form.pcustomerserial) {
          this.$message({
            message: '请选择加工点！',
            type: 'error'
          })
          return;
        }
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == this.form.pcustomerserial) {
            this.form.pcustomername = this.ptableData[i].deptname;
            break;
          }
        }

        createmachiningOrder(this.form).then((response) => {
          this.$message({
            message: '保存成功！',
            type: 'success'
          })
          this.$emit('bindGrid');
          this.dialogFormVisible = false;
        })

      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({filltemplates: 50, nocat: 1})
        })
      },
      initForm() {
      }
    },
    mounted() {
      // jxcstorelist().then(response => {
      //   this.jxcstoreData = response.data.obj
      //   this.form.cangkucode = this.jxcstoreData[0].cangkucode
      // })
    },
    components: {
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/AddMachinOrder.vue